import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=01a3421d&scoped=true&"
import script from "./UploadImg.vue?vue&type=script&lang=js&"
export * from "./UploadImg.vue?vue&type=script&lang=js&"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=01a3421d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a3421d",
  null
  
)

export default component.exports